import React, { FC } from 'react';
import { ESearchOptionSource, ESearchOptionType } from 'reactApp/ui/WebSearch/WebSearch.data';
import { WebSearchResetFiltersButton, WebSearchResetFiltersButtonProps } from 'reactApp/ui/WebSearch/WebSearchResetFiltersButton';

interface ResetWebSearchFiltersButtonProps extends WebSearchResetFiltersButtonProps {
    hook: () => {
        type: ESearchOptionType;
        source: ESearchOptionSource;
        onReset: (force?: boolean) => void;
    };
}

export const ResetWebSearchFiltersButton: FC<ResetWebSearchFiltersButtonProps> = ({ hook }) => {
    const { type, source, onReset } = hook();

    if (type === ESearchOptionType.all && source === ESearchOptionSource.all) {
        return null;
    }

    const handleReset = () => onReset(true);

    return <WebSearchResetFiltersButton onClick={handleReset}>Сбросить фильтр</WebSearchResetFiltersButton>;
};

ResetWebSearchFiltersButton.displayName = 'ResetWebSearchFiltersButton';
